import styled from 'styled-components'
import useBookLastRead from './useBookLastRead'
import BookReadingSessionButton from './reading/BookReadingSessionButton'
import BookPageBar from '../../common/BookPageBar'
import BooksitoutButton from '../../common/button/BooksitoutButton'
import LoadingBar from '../../common/LoadingBar'
import BookPageBarLoading from '../../common/BookPageBarLoading'
import BooksitoutImages from '../../images/BooksitoutImages'
import BookReadingSessionButtonLoading from './reading/BookReadingSessionButtonLoading'
import BooksitoutIcon from '../../config/BooksitoutIcon'
import { Author } from '../../common/Author'

const BookLastReadCard = () => {
	const [book, isLoading] = useBookLastRead()

	if (isLoading) {
		return (
			<Row>
				<ImageContainer>
					{/* @ts-ignore */}
                    <div>
					    <Image src={BooksitoutImages.Placeholder.bookCoverLoading} />
                    </div>
				</ImageContainer>

				<InfoContainer>
					<Title>
						<LoadingBar size={8} />
					</Title>
					<Author>
						<LoadingBar size={3} />
					</Author>
					<BookPageBarLoading />
					<BookReadingSessionButtonLoading />
				</InfoContainer>
			</Row>
		)
	}

	if (!book) {
		return (
			<div className="d-flex flex-column justify-content-center align-items-center w-100">
				<h3 className={'text-book'}>
					<BooksitoutIcon.bookXmark />
				</h3>
				<h5 className="text-center pb-3 fw-bold text-secondary">추가된 책이 없어요</h5>

				<BooksitoutButton message="책 추가하기 " url={'/add/book'} />
			</div>
		)
	}

	return (
		<Row href={`/book/mine/${book.id}`}>
			<ImageContainer>
				{/* @ts-ignore */}
                <div>
				    <Image src={book.cover} />
                </div>
			</ImageContainer>

			<InfoContainer>
				<Title>{book.title}</Title>
				<Author size={14}>{book.author?.split(',')[0] || ''}</Author>
				<BookPageBar book={book} />
				<BookReadingSessionButton book={book} size={300} />
			</InfoContainer>
		</Row>
	)
}

const Row = styled.a.attrs({
	className: 'row',
})`
	width: 100%;
`

const ImageContainer = styled.div.attrs({
	className: 'col-3 col-md-4',
})`
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
`

const InfoContainer = styled.div.attrs({
	className: 'col-9 col-md-8',
})`
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	padding: 0;
	margin: 0;

	&:hover {
		color: var(--sub-text-color);
	}

	color: var(--text-color);
`

const Image = styled.img.attrs({
	className: 'img-fluid rounded-3',
})`
	width: auto;
	max-height: 155px;
	object-fit: contain;
    border-radius: 10px;
`

const Title = styled.h6.attrs({
	className: 'clamp-1-line',
})``

export default BookLastReadCard
